module.exports = __webpack_public_path__ + "img/ok.767d216.png";